import { useEffect, useRef, useState } from "react";

const POLL_INTERVAL = 3 * 60 * 1000; // 3 minutes

/**
 * Polls /version.json every 3 minutes.
 * Returns true once the fetched version differs from the version that was
 * current when the app first loaded.
 */
export function useVersionCheck() {
  const initialVersion = useRef(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function checkVersion() {
      try {
        const res = await fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" });
        if (!res.ok || cancelled) return;
        const data = await res.json();
        const v = String(data.version ?? "");
        if (cancelled) return;
        if (initialVersion.current === null) {
          // First load — capture the running version
          initialVersion.current = v;
        } else if (v !== initialVersion.current) {
          setUpdateAvailable(true);
        }
      } catch {
        // Network error — silently ignore
      }
    }

    checkVersion();
    const timer = setInterval(checkVersion, POLL_INTERVAL);

    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  return updateAvailable;
}
